<template>
    <v-list-item
        :href="href"
        @click.prevent="router.visit(href + (query ? '?trackquery=' + query : ''));emit('linkClick')"
        :prepend-avatar="image">
        <v-list-item-title>
            <div class="text-tiny-link font-weight-bold text-black mb-1 text-overflow" v-html="name"></div>
        </v-list-item-title>
        <v-list-item-subtitle v-if="stock_number">
            <div class="text-tiny-link"><b>{{$t('eshop::customer-orders-page.stock_number')}}:</b> <span v-html="stock_number"></span></div>
        </v-list-item-subtitle>
        <template v-slot:prepend>
            <v-img
                aspect-ratio="1"
                width="64"
                :src="image"
                class="mr-2"
            >
            </v-img>
        </template>
        <template v-slot:append>
            <div class="text-right">
                <div class="mb-1 mt-1">
                    <div v-if="product.your_sale" class="text-body-2 font-italic text-decoration-line-through mb-n2">{{ product.price_no_discount_with_vat }}</div>
                    <div class="text-subtitle-1 font-weight-bold font-italic"><small class="font-weight-regular" v-if="$page.props.customer?.email">{{ $t('eshop::product-details.retail_price_shortcut') }}: </small><span :class="product.your_sale ?'text-red':''" v-html="product.moc_price"></span></div>
                </div>
                <availability-info-nibblet :availability="product.availability" density="compact"></availability-info-nibblet>

            </div>
        </template>
    </v-list-item>
</template>

<script setup>
import {router} from "@inertiajs/vue3";
import AvailabilityInfoNibblet from "../../../motonet/modules/eshop/frontend/AvailabilityInfoNibblet.vue";
import PriceHider from "../../../motonet/modules/eshop/frontend/PriceHider.vue";

defineProps({
    product: Object,
    href: String,
    image: String,
    price: String,
    stock_number: String,
    name: String,
    query: String
})
const emit = defineEmits(['linkClick'])
</script>

<style scoped lang="scss">
.v-list-item{
    :deep(.v-list-item__append){
        align-self: center !important;
        padding-top: 0 !important;
    }
    :deep(.v-list-item__prepend){
        padding-top: 0 !important;
    }
}
.text-overflow {
    white-space: wrap;
}
</style>
